import { ScheduledPost } from "src/features/feed/types/scheduled-posts.entity";
import { ScheduledPostCard } from "./card";

export const ScheduledPosts = ({ posts }: { posts: ScheduledPost[] }) => {
  return (
    <>
      {posts.map((post) => (
        <ScheduledPostCard post={post} key={post.id} />
      ))}
    </>
  );
};
